export default __webpack_public_path__ + "static/media/incorrect-feedback-icon.cbffc7f5.svg";